module.exports = __webpack_public_path__ + "static/media/g2_logo_back.31ec6acd.svg";